/* eslint-disable no-undef */
import { isBefore, isAfter } from 'date-fns';

async function loadPost() {
    const main = document.getElementById('main');
    const formData = new FormData();
    formData.append('action', 'talk_refresh');
    formData.append('id', ajax.id);
    try {
        const response = await fetch(ajax.ajaxurl, {
            method: 'POST',
            body: formData,
        });
        const html = await response.text();

        if (html) {
            main.innerHTML = html;
        }
    } catch (error) {
        console.log(error);
    }
}

// before, during, after
let status;

const getStatus = () => {
    let value;
    const now = new Date();

    if (isBefore(now, new Date(ajax.startDate))) {
        value = 'before';
    }

    if (isAfter(now, new Date(ajax.startDate)) && isBefore(now, new Date(ajax.endDate))) {
        value = 'during';
    }

    if (isAfter(now, new Date(ajax.endDate))) {
        value = 'after';
    }

    return value;
};

const talkRefresh = () => {
    status = getStatus();
    setInterval(() => {
        if (status !== getStatus()) {
            status = getStatus();
            loadPost();
        }
    }, 10000);
};

talkRefresh();
